import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { UserContext } from '../App';

export { carrierAuthCondition, shipperAuthCondition } from './authConditions';

const withAuthorization = (authCondition) => (Component) => (props) => {
    const navigate = useNavigate();

    const { user } = useContext(UserContext);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        if (authCondition(user)) {
            setIsAuthorized(true);
        } else {
            navigate('/account');
        }
    }, [user]);

    return isAuthorized ? <Component {...props} /> : null;
};

export default withAuthorization;
